import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { RefSetter } from '../Utils/RefSetter';
import { FieldName } from '../Types/Intyg.enums';

export interface IValjYrkeProps {}
export interface IValjYrkeState extends FormSectionBaseState {}

export default class ValjYrke extends FormSectionBase<IValjYrkeProps, IValjYrkeState> {
  constructor(props: IValjYrkeProps) {
    super(props);

    this.fieldRefs.set(FieldName.YrkeId, React.createRef<SelectBox>());

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { Translate, yrken, model } = this.context;
    return (
      <div>
        <RefSetter fieldRefs={this.fieldRefs}>
          <section className="m-b-4">
            <SelectBox
              onChange={this.onChangeField}
              label={Translate('valjyrke') + ' (obligatoriskt)'}
              className="max25"
              defaultOptionText={Translate('valj')}
              fieldName={FieldName.YrkeId}
              options={yrken}
              errorMessage={this.getErrorMessage(FieldName.YrkeId)}
              isRequired={true}
              value={model.yrkeId}
            />
          </section>
        </RefSetter>
      </div>
    );
  }
}
